jQuery_PersonaliseButton = function (){
    window.customized = false;
    jQuery('#personalizeButton')
         .DesignsDirect({
           clientId: 'clientId',
           apiKey: 'apiKey',
           apiVersion: 'apiVersion',
           onSave: function(action, data)
              {
               jQuery(".product-form__submit").prop('disabled',false);
               console.log('onSave'); 
               console.log(action);
               console.log(data); 
               console.log('data.imageUrl');

               console.log(data.imageURL);
               jQuery('#hiddeninputforrefnum').val(data.refnum);
               let previewURL = data.imageURL.startsWith('//')?data.imageURL.replace('//','https://'):data.imageURL;
               console.log('preveiw URL: '+previewURL);
               jQuery('#hiddeninputforpreviewimage').val(previewURL)
               arraySrcSet = []
               jQuery(jQuery('.product__media img:first-of-type').attr('srcset').split(',')).each(
                function(idx,el){
                  let imgUrl = el.trim().replace(/^(\/\/)[\w|./-]*/, data.imageURL)
                  imgUrl = imgUrl.replace(/\?v=\d+/,'\?v='+Date.now())
                    arraySrcSet.push(imgUrl);
                }
            )
               console.log(this.personalize_btn)
               jQuery(this.personalize_btn).text('Edit customization');
               window.customized = true;
               //jQuery('.product-image-main img').attr('srcset',arraySrcSet.join(','));
               console.log(jQuery('#hiddeninputforpreviewimage').val())
             }
           })
}
jQuery_PersonaliseButton();